const unidadToString = {}

function convertUnidadToEString (eInt) {
  let eStr
  switch (eInt) {
    case 'PZA':
      eStr = 'PIEZAS(s)'
      break
    case 'LT':
      eStr = 'LITRO(s)'
      break
    case 'PACK':
      eStr = 'PAQUETE(s)'
      break
    case 'BOX':
      eStr = 'CAJA(s)'
      break
    default:
      eStr = ''
      break
  }
  return eStr
}

unidadToString.install = function (Vue) {
  Vue.filter('unidadToHtml', (val) => {
    return convertUnidadToEString(val)
  })
}



export default unidadToString



// WEBPACK FOOTER //
// ./src/filters/unidad.js